

import styles from './index.module.scss'
import { Button, Dropdown, Popover } from 'antd';
import Iconfont from '@utils/Iconfont';
import Utils from '@utils/utils';
import { BATCH_IMAGES_TYPE, RELIGHT_MODE, MODEL_EXPRESSION, MODEL_PROVIDER } from '@utils/CONST'
import { DownOutlined, LoadingOutlined } from '@ant-design/icons';
import { useMemo, useEffect, useRef, useState } from 'react';
const notUploadUrl = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/batchProduceImages/notuploaded.png'

const RenderItem = ({ title, imgUrl, width, showNum, num }) => (
    <div className={styles.groupWrapLeftItem}>
        <p className={styles.itemTitle} style={width ? { width } : {}}>{title || ' '}</p>
        <div className={styles.groupWrapLeftItemImg} style={width ? { width } : {}}>
            <img src={imgUrl ? Utils.getImgThumbnail(imgUrl) : notUploadUrl} alt="" style={width ? { width } : {}} />
            {showNum && <p className={styles.imgNum}>数量{num}</p>}
        </div>
    </div>
)

const RenderMultiItem = ({ title, items, onClick, totalCount, showNum, maxCount }) => (
    <div
        onClick={onClick}
        className={`${styles.groupWrapLeftItem} ${styles.groupWrapLeftItem2}`} >
        <p className={styles.itemTitle}>{title || ' '}</p>
        {
            items?.map((ref, index) => (
                <div key={index} className={`${styles.groupWrapLeftItemImg} ${index == maxCount - 1 ? styles.groupWrapLeftItemImg_F : ''}`}>
                    <img src={Utils.getImgThumbnail(ref?.url)} alt="" />
                    {index == maxCount - 1 && <div className={styles.groupWrapLeftItemImg_F_Text}>+{totalCount}件</div>}
                    {showNum && index != maxCount - 1 && <p className={styles.imgNum}>数量{ref.num}</p>}
                </div>
            ))
        }
    </div>
)

const GroupWrapLeft = (props) => {
    const { item, projectType, refListModalRef, regenerateByTaskId, reEditClick } = props
    const getModelProviderLabel = (value) => {
        if (!value) return ''
        if (value === MODEL_PROVIDER.SOTA || value?.toLowerCase?.() === 'sota') return '全能模型'
        if (value === MODEL_PROVIDER.ARCMUSE || value?.toLowerCase?.() === 'arcmuse') return 'ArcMuse'
        return value
    }
    const getModeLabel = (mode, provider, forceHq = false) => {
        const isSota = provider === MODEL_PROVIDER.SOTA || provider?.toLowerCase?.() === 'sota'
        const isHq = forceHq || mode != 'std'
        if (isSota) return isHq ? '高品质模式4K' : '标准模式2K'
        return isHq ? '高品质模式' : '标准模式'
    }
    const items = {
        [BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH]: [
            { label: <p className={styles.Dropdown_p} ><span>肤质高清</span><span>{item[0]?.attr?.skinRefine == 1 ? '开' : '关'}</span></p>, key: 'taskDetail' },
            { label: <p className={styles.Dropdown_p} ><span>光影增强</span><span>{item[0]?.attr?.relight == 1 && (item[0]?.attr?.relightMode === RELIGHT_MODE.REFLECTOR ? "反光板模式" : "标准模式")} {item[0]?.attr?.relight == 1 ? '开' : '关'}</span></p>, key: 'taskDetail' },
            { label: <p className={styles.Dropdown_p} ><span>模特表情</span><span>{item[0]?.attr?.emoji == MODEL_EXPRESSION.REF ? '按模特参考图' : '按原模特'}</span></p>, key: 'taskDetail' }
        ],
        [BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH]: [
            { label: <p className={styles.Dropdown_p} ><span>光影增强</span><span>{item[0]?.attr?.relight == 1 && (item[0]?.attr?.relightMode === RELIGHT_MODE.REFLECTOR ? "反光板模式" : "标准模式")} {item[0]?.attr?.relight == 1 ? '开' : '关'}</span></p>, key: 'taskDetail' },
            { label: <p className={styles.Dropdown_p} ><span>场景相似度</span><span>{item[0]?.attr?.customBkgMode == 'free' ? '变化更多' : '场景不变'}</span></p>, key: 'taskDetail' },
            { label: <p className={styles.Dropdown_p} ><span>生成比例</span><span>{item[0]?.attr?.resolutionAlign == 'input' ? '上传图比例' : '参考图比例'}</span></p>, key: 'taskDetail' }
        ]
    }

    const renderContent = () => {
        const data = item[0]
        const list = []

        if (projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
            list.push({
                type: 'multi',
                title:  '穿搭商品图',
                prompt: data?.attr?.prompt,
                items: data?.inputImages?.slice(0, 3),
                totalCount: data?.inputImages?.length,
                onClick: () => refListModalRef.current.open(data?.inputImages),
                maxCount: 3
            })
        } else {
            const mainImg = data?.inputImages?.filter(i => i.mainImage)[0]
            const titleMap = {
                [BATCH_IMAGES_TYPE.TRYON_BATCH]: '商品图',
                [BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH]: '输入图',
                [BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH]: '源素材',
                [BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH]: '首帧图'
            }
            list.push({
                type: 'single',
                title: titleMap[projectType] || '模特图',
                imgUrl: mainImg?.url,
                showNum: false,
                num: data?.inputImages?.[0]?.num
            })
        }

        // TryOn Match Image
        if (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH) {
            const matchImg = data?.inputImages?.filter(i => !i.mainImage)[0]
            list.push({
                type: 'single',
                title: matchImg?.url ? '搭配图' : '未选搭配图',
                imgUrl: matchImg?.url
            })
        }

        if (projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
            list.push({
                type: 'single',
                title: data?.attr?.imageTail ? '尾帧图' : '未选尾帧图',
                imgUrl: data?.attr?.imageTail
            })
        }

        // Model Image
        if ([BATCH_IMAGES_TYPE.TRYON_BATCH, BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH, BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH].includes(projectType)) {
            const person = data?.attr?.person
            const title = person?.url ? (projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? '模特图' : person?.title?.split('-').pop()) : '未选模特图'
            list.push({
                type: 'single',
                title,
                imgUrl: person?.url
            })
        }

        // Sim Recolor
        if (projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH) {
            list.push({
                type: 'single',
                title: data?.attr?.flatType === 'material' ? '面料图' : '同款不同色平铺图',
                imgUrl: data?.attr?.inputCloth,
                width: '128px'
            })
            if (data?.attr?.matchCloth) {
                list.push({
                    type: 'single',
                    title: '搭配图',
                    imgUrl: data?.attr?.matchCloth,
                    width: '128px'
                })
            }
        }


        // Change Bkg
        if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH || projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
            const bkg = data?.attr?.background
            list.push({
                type: 'single',
                title: bkg?.url ? bkg?.title : '未选背景图',
                imgUrl: bkg?.url
            })
        }

        // TryOn Pose
        if (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH) {
            const pose = data?.attr?.pose
            list.push({
                type: 'single',
                title: pose?.url ? '姿势图' : '未选姿势图',
                imgUrl: pose?.url
            })
        }

        return list.map((conf, index) => {
            if (conf.type === 'multi') return <RenderMultiItem key={index} {...conf} />
            return <RenderItem key={index} {...conf} />
        })
    }

    // 提示词
    const promptTextRef = useRef(null)
    const [promptOverflow, setPromptOverflow] = useState(false)
    const [promptPopoverOpen, setPromptPopoverOpen] = useState(false)
    const promptText = useMemo(() => {
        return item?.[item?.length - 1].attr?.prompt
    }, [item])
    useEffect(() => {
        const el = promptTextRef.current
        if (!el) return
        setPromptOverflow(el.scrollHeight > el.clientHeight + 1)
    }, [promptText])

    return (
        <div className={styles.groupWrapLeft} style={{ width: projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? '220px' : '420px' }}>
            <p className={styles.groupWrapLeftItemTitle}>
                {
                    (projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
                        projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) &&
                    <Dropdown menu={{ items: items[projectType] || [] }}>
                        <a onClick={e => e.preventDefault()}>
                            <>
                                任务详情 <DownOutlined />
                            </>
                        </a>
                    </Dropdown>
                }
                {
                    projectType == BATCH_IMAGES_TYPE.TRYON_BATCH || projectType == BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH || projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH
                        ? <span>
                            {
                                ((projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && (item[0]?.attr?.imageTail || item[0]?.imageTail)) || item[0]?.attr?.mode != 'std') ?
                                    <><Iconfont className={styles.Iconhq} type="icon-qualityModeOutlined" /> {getModeLabel(item[0]?.attr?.mode, item[0]?.attr?.modelProvider || item[0]?.modelProvider, true)}</> :
                                    <><Iconfont className={styles.Iconstd} type="icon-fastModeOutlined" /> {getModeLabel(item[0]?.attr?.mode, item[0]?.attr?.modelProvider || item[0]?.modelProvider)}</>
                            }
                        </span> : null
                }
                {/* {
                    projectType == BATCH_IMAGES_TYPE.TRYON_BATCH && (item[0]?.attr?.modelProvider || item[0]?.modelProvider) &&
                    <span className={styles.taskSerial}>模型：{getModelProviderLabel(item[0]?.attr?.modelProvider || item[0]?.modelProvider)}</span>
                } */}
                <span className={styles.taskSerial}>任务ID：{item[0]?.taskSerial}</span>
            </p>
            {
                projectType != BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH && (
                    (!promptText && projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) ?
                        <LoadingOutlined style={{ width: 16, height: 16 }} /> :
                        <div className={styles.promptTextWrap}>
                            <span ref={promptTextRef} className={styles.promptText}>{promptText}</span>
                            {promptOverflow && (
                                <Popover
                                    open={promptPopoverOpen}
                                    onOpenChange={setPromptPopoverOpen}
                                    trigger="hover"
                                    placement="bottom"
                                    content={<div className={styles.promptPopoverContent}>{promptText}</div>}
                                >
                                    <span className={styles.viewAll}>查看全部</span>
                                </Popover>
                            )}
                        </div>
                )
            }
            <div className={styles.groupWrapLeftItemWrap}>
                {renderContent()}
            </div>
            {
                !item[0]?.orgData && <div className={styles.groupWrapBtns}>
                    {
                        (projectType != BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH &&
                            projectType != BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) &&
                        <Button
                            style={{ width: 200, height: 32, marginRight: 12 }}
                            onClick={() => reEditClick(item[0]?.projectId, item[0]?.skuId, item[0]?.taskId)}>重新编辑</Button>
                    }
                    {
                        <Button style={{ width: 200, height: 32 }} onClick={() => regenerateByTaskId(item[0]?.taskId)}>再次生成</Button>
                    }
                </div>
            }
        </div>
    )
}

export default GroupWrapLeft
